import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import materialRoutes from "app/views/material-kit/MaterialRoutes";
// Lazy-loaded components
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtRegister = Loadable(lazy(() => import("app/views/sessions/JwtRegister")));
const ForgotPassword = Loadable(lazy(() => import("app/views/sessions/ForgotPassword")));
const ResetPassword = Loadable(lazy(() => import("app/views/sessions/ResetPassword")));
const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
const AddMarks = Loadable(lazy(() => import("app/views/teacher/AddMarks")));
const AddAttendance = Loadable(lazy(() => import("app/views/teacher/AddAttendance")));
const AppEchart = Loadable(lazy(() => import("app/views/charts/echarts/AppEchart")));
const TeacherDashboard = Loadable(lazy(() => import("app/views/dashboard/shared/TeacherDashboard"))); // Add TeacherDashboard
const LibrarianDashboard = Loadable(lazy(() => import("app/views/dashboard/shared/LibrarianDashboard")));
const StudentDashboard = Loadable(lazy(() => import("app/views/dashboard/shared/StudentDashboard")));
const AdmissionRequest = Loadable(lazy(() => import("app/views/sessions/AdmissionRequest")));
const PrivacyPolicy = Loadable(lazy(() => import("app/views/sessions/PrivacyPolicy")));
const Admission = Loadable(lazy(() => import("app/views/sessions/Admission")));
// const AdmissionRequest = Loadable(lazy(() => import("app/views/sessions/AdmissionRequest")));
const AdmissionStatus = Loadable(lazy(() => import("app/views/sessions/AdmissionStatus")));
const AdmissionPayment = Loadable(lazy(() => import("app/views/sessions/AdmissionPayment")));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      {
        path: "/dashboard/default",
        element: <Analytics />,
        auth: authRoles.adminTeacherStudent, // Allow ADMIN and TEACHER
      },
      {
        path: "/teacher/AddMarks",
        element: <AddMarks />,
        auth: authRoles.teacher, // Only TEACHER can access
      },
      {
        path: "/TeacherDashboard",
        element: <TeacherDashboard />, // Add TeacherDashboard route
        auth: authRoles.teacher, // Only TEACHER can access
      },
      {
        path: "/LibrarianDashboard",
        element: <LibrarianDashboard />, // Add TeacherDashboard route
        auth: authRoles.librarian, // Only TEACHER can access
      },
      {
        path: "/StudentDashboard",
        element: <StudentDashboard />, // Add TeacherDashboard route
        auth: authRoles.student, // Only TEACHER can access
      },
      {
        path: "/teacher/AddAttendance",
        element: <AddAttendance />,
        auth: authRoles.teacher, // Only TEACHER can access
      },
      {
        path: "/charts/echarts",
        element: <AppEchart />,
        auth: authRoles.editor, // Only EDITOR can access
      },
    ],
  },
  // Session Pages
  { path: "/session/404", element: <NotFound /> },
  { path: "/session/signin", element: <JwtLogin /> },
  { path: "/session/signup", element: <JwtRegister /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "/session/reset-password", element: <ResetPassword /> },
  { path: "/session/AdmissionRequest", element: <AdmissionRequest /> },
  { path: "/session/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/session/Admission", element: <Admission /> },
  { path: "/session/AdmissionStatus", element: <AdmissionStatus /> },
  { path: "/session/AdmissionPayment", element: <AdmissionPayment /> },
  // Default Redirect
  { path: "/", element: <Navigate to="/session/signin" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;